var exports = {
  "Nr": "AppDiscoveryCard.module__card___Qm5OUj",
  "vK": "AppDiscoveryCard.module__banner___Qm5OUj",
  "Qs": "AppDiscoveryCard.module__content___Qm5OUj",
  "mY": "AppDiscoveryCard.module__topRow___Qm5OUj",
  "R3": "AppDiscoveryCard.module__avatarWrapper___Qm5OUj",
  "my": "AppDiscoveryCard.module__avatar___Qm5OUj",
  "HE": "AppDiscoveryCard.module__verifiedCheck___Qm5OUj",
  "a$": "AppDiscoveryCard.module__categoryPill___Qm5OUj",
  "S7": "AppDiscoveryCard.module__nameRow___Qm5OUj",
  "UU": "AppDiscoveryCard.module__name___Qm5OUj",
  "dS": "AppDiscoveryCard.module__tagline___Qm5OUj",
  "qr": "AppDiscoveryCard.module__footer___Qm5OUj",
  "zl": "AppDiscoveryCard.module__serverCount___Qm5OUj",
  "w5": "AppDiscoveryCard.module__addBtn___Qm5OUj",
};

module.exports = exports;
